import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addfooterDisposition from "./components/addfooterDisposition";
export default {
  name: "footerDisposition",
  mixins: [loadMoreList, serchSelect],
  components: {
    addfooterDisposition: addfooterDisposition
  },
  data: function data() {
    return {
      pagingReqFn: "copyrightData",
      pagingReqValue: "",
      drawer: false,
      content: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = this.$utils.textRepl(row.copyright);
      this.drawer = true;
    },
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'copyrightDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};